module.exports = __webpack_public_path__ + "media/images/mission-6094fb4e.png";